import React from 'react'
import logo from '../assets/images/connect-api-logo.png'
import '../app.scss'

export default () => (
  <header className="app-header">
    <img src={logo} className="app-logo" alt="cs-connect-logo"/>
  </header>
)



// WEBPACK FOOTER //
// ./src/components/logo-header.js